import { DynamicEmbeddedWidget } from '@dynamic-labs/sdk-react-core';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

// Styles
import { ValueSansPro } from 'Components/ds/MapleTheme/typography';

const EmailSignup = () => {
  const { palette, spacing } = useTheme();

  return (
    <Box
      sx={{
        '.embedded-widget': { width: '100%', fontFamily: `${ValueSansPro} !important` },
        '.typography': {
          fontFamily: `${ValueSansPro} !important`,
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '18px',
          '&--bold': {
            color: palette.ds.neutral[900],
            fontWeight: 500,
          },
        },
        '.modal-header': { display: 'none' },
        '.login-with-email__container': { padding: 0 },
        '.login-with-email__error-container': { marginBottom: 3 },
        '.email-verification__container': { padding: 0 },
        '.tos-and-pp__footer': { display: 'none' },
        '.social-sign-in--tile': {
          backgroundColor: palette.ds.neutral[50],
          height: spacing(7),
          borderRadius: '12px',
          ':hover': {
            backgroundColor: `${palette.ds.neutral[50]} !important`,
            boxShadow: 'none !important',
          },
        },
        '.typography--button-primary': {
          fontSize: '16px',
          fontWeight: 500,
          color: palette.ds.neutral[900],
        },
        '#email_field': {
          border: 'none',
          backgroundColor: palette.ds.neutral[50],
          height: spacing(7),
        },
        '.input__label': {
          fontSize: '16px',
          color: palette.ds.neutral[200],
        },
        '.input__container--dense .input:placeholder-shown~.input__label': {
          top: spacing(2),
        },
        '.button': {
          height: spacing(6),
          boxShadow: 'none',
          border: 'none',
        },
        '.button--brand-primary .typography': {
          fontSize: '16px',
          color: palette.ds.text.contrast,
        },
        '.login-with-email-form': {
          gap: spacing(3),
        },
        '.dynamic-footer': {
          display: 'none',
        },
        '.email-verification__icon-with-spinner': {
          display: 'none',
        },
        '.email-verification__text-button': {
          color: palette.ds.primary[500],
          fontSize: '14px',
          ':hover': {
            background: 'none',
          },
        },
      }}
    >
      <DynamicEmbeddedWidget background='none' />
    </Box>
  );
};

export default EmailSignup;
